// License & Privileges Power Sync - start
export const FETCH_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST = 'FETCH_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST';
export const FETCH_LICENSE_PRIVILEGES_POWER_SYNC_SUCCESS = 'FETCH_LICENSE_PRIVILEGES_POWER_SYNC_SUCCESS';
export const FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FAILURE = 'FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FAILURE';

export const FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_REQUEST = 'FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_REQUEST';
export const FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_SUCCESS = 'FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_SUCCESS';
export const FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_FAILURE = 'FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_FAILURE';

export const EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST = 'EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST';
export const EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_SUCCESS = 'EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_SUCCESS';
export const EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_FAILURE = 'EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_FAILURE';
// License & Privileges Power Sync - end
